export default "__VITE_ASSET__2ac676f5__"